webpackJsonp([238934823523655],{

/***/ 403:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _ArvindThakur = __webpack_require__(99);
	
	var _ArvindThakur2 = _interopRequireDefault(_ArvindThakur);
	
	var _Deepak_Kapoor_new = __webpack_require__(100);
	
	var _Deepak_Kapoor_new2 = _interopRequireDefault(_Deepak_Kapoor_new);
	
	var _LalitaGupte = __webpack_require__(101);
	
	var _LalitaGupte2 = _interopRequireDefault(_LalitaGupte);
	
	var _ManishaGirotra = __webpack_require__(102);
	
	var _ManishaGirotra2 = _interopRequireDefault(_ManishaGirotra);
	
	var _padmajaRuparel = __webpack_require__(108);
	
	var _padmajaRuparel2 = _interopRequireDefault(_padmajaRuparel);
	
	var _persistentRoshiniBakshi = __webpack_require__(110);
	
	var _persistentRoshiniBakshi2 = _interopRequireDefault(_persistentRoshiniBakshi);
	
	var _sujoyBose = __webpack_require__(111);
	
	var _sujoyBose2 = _interopRequireDefault(_sujoyBose);
	
	var _VT = __webpack_require__(105);
	
	var _VT2 = _interopRequireDefault(_VT);
	
	var _geeta = __webpack_require__(106);
	
	var _geeta2 = _interopRequireDefault(_geeta);
	
	var _neelam = __webpack_require__(107);
	
	var _neelam2 = _interopRequireDefault(_neelam);
	
	var _pallavi = __webpack_require__(109);
	
	var _pallavi2 = _interopRequireDefault(_pallavi);
	
	var _SanjeevKrishnan = __webpack_require__(103);
	
	var _SanjeevKrishnan2 = _interopRequireDefault(_SanjeevKrishnan);
	
	var _ShwetaJalan = __webpack_require__(104);
	
	var _ShwetaJalan2 = _interopRequireDefault(_ShwetaJalan);
	
	var _Harsh = __webpack_require__(78);
	
	var _Harsh2 = _interopRequireDefault(_Harsh);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var icon12 = "https://www.winpeforum.com/assets/elements/NithyaEaswaran.png";
	var icon17 = "https://www.winpeforum.com/assets/elements/KalpeshJain.jpg";
	var icon18 = "https://www.winpeforum.com/assets/elements/MatangiGowrishankar.png";
	var icon19 = "https://www.winpeforum.com/assets/elements/RoshiniBakshi.jpg";
	var icon20 = "https://www.winpeforum.com/assets/elements/VineetRai.png";
	var icon21 = "https://www.winpeforum.com/assets/elements/KanwaljitSingh.png";
	var icon22 = "https://www.winpeforum.com/assets/elements/ShirishGodbole.png";
	var icon23 = "https://www.winpeforum.com/assets/elements/VaibhavGupta.png";
	var icon24 = "https://www.winpeforum.com/assets/elements/SheebuDavid.png";
	
	var icon25 = "https://www.winpeforum.com/assets/elements/AshleyMenezes.png";
	var icon26 = "https://www.winpeforum.com/assets/elements/Bala.png";
	var icon27 = "https://www.winpeforum.com/assets/elements/RenukaRam.png";
	var icon28 = "https://www.winpeforum.com/assets/elements/Pallavi.png";
	var icon29 = "https://www.winpeforum.com/assets/elements/ShivaniBhasin.png";
	var icon30 = "https://www.winpeforum.com/assets/elements/VTBharadwaj.png";
	var icon31 = "https://www.winpeforum.com/assets/elements/AnjaliSosale.png";
	var icon32 = "https://www.winpeforum.com/assets/elements/SujoyBose.png";
	var icon7 = "https://www.winpeforum.com/assets/elements/SoumyaRajan.png";
	
	var mentors_constants = [{
	  imgUrl: icon31,
	  into: "Anjali Sosale is a GP at WaterBridge Ventures where she focuses on consumption and the gig economy. She was previous with Myntra Jabong and EY in leadership roles and is based in Bangalore. WaterBridge is a VC firm that partners with founders early, with a $1-3M cheque and continues to invest until Series C.",
	
	  name: "Anjali Sosale",
	  post: "Partner  ",
	  cmp: "WaterBridge Ventures",
	  link: "https://www.linkedin.com/in/pinkamma/"
	
	}, {
	  imgUrl: _Harsh2.default,
	  into: " ",
	  desc: "Accomplished business leader with expertise in Emerging Markets investing, building highly profitable investment businesses from the scratch, and setting and growing up multiple investment platforms.\n<br/><br/>\nSpotted trends early on and used this to build large investments through the platform, in a manner that assets are well diversified to optimize returns.\n<br/><br/>\nEarly investor in Sustainability for 15 years, built platforms, and invested in global technology businesses. During his career he has worked on financial investments across products and industries; advised CEOs on businesses and financial strategy, and built teams.\n<br/><br/>\nKey career highlights include building IFC\u2019s renewable investing business, conceptualizing and building India\u2019s largest road platform and setting up CDPQ India business across public equity, private equity, infra and fixed income.\n<br/><br/>\nThrough these journeys he has gained rich experience in scaling up businesses, driving sustainability, and corporate governance. Leading large global projects in multi-country and cultural settings. Negotiating documents under international tax and corporate laws. Building value creation strategies, executing these and steering organizational change.",
	  name: "Harsh Singhal",
	  post: "Partner",
	  cmp: "ProsperETE",
	  link: "https://www.linkedin.com/in/harsh-singhal-8321844/?originalSubdomain=in"
	
	}, {
	  imgUrl: icon17,
	  into: " ",
	  desc: "Kalpesh is a Managing Director and Chief Financial Officer at Multiples. His purview spans Operational, Financial, and Risk Management facets, covering Fund Raising, Pre and Post Investment processes, Legal, Compliance, ESG integration, Fund Administration, Technology, and Taxation. At the portfolio company level, Kalpesh leads pre-investment activities, including Due Diligence in Financial, Legal, and ESG domains, as well as transaction structuring and legal documentation. Post-investment, he oversees Portfolio Management, encompassing performance reviews, monitoring value creation plans, Compliance, ESG adherence, and robust Risk Management. Kalpesh's overarching goal is to cultivate efficient and scalable businesses, contributing to the development of valuable and sustainable organizations at both the Portfolio Company and Fund levels. This involves building strong Portfolio Companies with superior returns, emphasizing Compliance, Governance, and Environmental and Social responsibility to enhance overall value.\n\n        <br/><br/>\nPrior to Multiples, he worked in the Assurance Practice at Ernst & Young and Arthur Andersen for 18 years. As a Partner with E&Y, he led assignments in sectors like Technology, Fintech, Media, E-commerce, Logistics, and Consumer Goods. He brings extensive experience working on IPOs both in India and US and supported companies in Mergers & Acquisitions.\n",
	  name: "Kalpesh Jain",
	  post: "Managing Director and CFO",
	  cmp: "Multiples Alternate Asset Management Private Limited ",
	  link: "https://www.linkedin.com/in/kalpeshrjain/"
	
	}, {
	  imgUrl: icon21,
	  into: "Kanwal has always been passionate about mentoring and helping build consumer brands in India",
	  desc: "Kanwal has always been passionate about mentoring and helping build consumer brands in India, and has been involved as an investor with brands like Paper Boat, ID Fresh, Epigamia, and Licious, before starting Fireside. He has been investing in the early stage ecosystem in India for the past 17 years, first as a Director at Carlyle Group, India, and later as a Co-Founder and Senior Managing Director of Helion Venture Partners. Prior to his investing career, Kanwal spent over 13 years in consumer marketing with Hindustan Unilever, and Intel India.\n        ",
	  name: "Kanwaljit Singh",
	  post: "Managing Partner",
	  cmp: "Fireside Ventures",
	  link: "https://in.linkedin.com/in/singhkanwaljit"
	}, {
	  imgUrl: icon12,
	  into: "Nithya has over 24 years of rich experience in financial services. She is Managing Director of Multiples Alternate Asset Management,  a private equity platform with AUM of over US$1.5 billion. ",
	  desc: "Nithya has over 25 years of rich experience in financial services. She is Managing Director of Multiples Alternate Asset Management, a private equity platform with AUM of over US$ 2 billion.<br/><br/>\n     \n            Nithya joined Multiples in 2010 and has led several investments made by the platform. She is a Director on the Board of Multiples and a part of the Investment Committee. She leads the financial sector investing practice and focuses on creating a franchise with top corporate houses. Nithya developed Multiples\u2019 proprietary framework - Leadership Energy Level - to analyze the DNA of entrepreneurs.<br/><br/>\n             \n            Nithya is a Director on the Board of Arvind Fashions and APAC Financial Services. She is a founding member of the India Chapter of Bloomberg Women\u2019s Buyside Network. The Association of International Wealth Management of India featured her amongst India\u2019s Top 100 Women in Finance 2020.<br/><br/>\n             \n            Prior to joining Multiples, Nithya had a 14-year banking career across Citibank and ICICI focused on structured finance. In her banking stint, she has pioneered several unique securitisation, mezzanine debt and leveraged finance transactions. She holds an engineering degree from VJTI, Mumbai and an MBA from IIM, Lucknow.\n            <br/><br/>\n            Nithya enjoys spending time with her teenage son, loves reading and connecting with nature. She dedicates time over the weekends for teaching Maths to disadvantaged children.\n            \n           </div>",
	  name: "Nithya Easwaran",
	  post: "Managing Director",
	  cmp: "Multiples Alternate Asset Management",
	  link: "https://www.linkedin.com/in/nithyaeaswaran"
	}, {
	  imgUrl: icon28,
	  into: "Pallavi is a Partner in the International Capital Markets practice and is also the Joint Chair of Allen & Overy's India Group",
	  desc: "Pallavi is a Partner in the International Capital Markets practice and is also the Joint Chair of Allen & Overy's India Group. Pallavi\u2019s practice focuses on debt and equity capital markets transactions in India and across the Asia Pacific region where she has over 18 years of experience advising issuers, underwriters and sponsors on Rule 144A and Regulation S international debt offerings, equity-linked offerings of exchangeable and convertible bonds, and equity offerings.<br/><br/>\n \n        Pallavi also has significant experience in bond restructurings, consent solicitations, exchange offers, induced conversions and tender offers. Many of the transactions she has advised on have been complex, innovative and award-winning.<br/><br/>\n         \n        Pallavi is qualified as a solicitor in India, England and Wales and Singapore.<br/><br/>\n         \n        Pallavi is consistently ranked in leading benchmarking publications. She is ranked as a highly regarded practitioner in IFLR1000 2019 and listed in the top 100 India-focused legal experts outside the country by India Business Law Journal. Clients say \u201CPallavi is considered a debt specialist, and well known for her focus on the Indian market.\u201D Chambers Asia Pacific describes her as \u201Cmeticulous and detail-oriented, has excellent legal skills and an ability to work well with Indian clients and Indian lawyers and a great deal lawyer and an asset to the team.\u201D Asia Pacific Legal 500 states that Pallavi is \u201Cextremely strong on knowledge, professionalism and accessibility\u201D and is \u201Cbusiness-friendly and willing to work at solving problems\u201D.\n        ",
	  name: "Pallavi Gopinath Aney",
	  post: "Partner",
	  cmp: "Allen & Overy",
	  link: "https://www.linkedin.com/in/pallavi-gopinath-aney-5922292/"
	
	}, {
	  imgUrl: icon29,
	  into: "Shivani Bhasin Sachdeva",
	  desc: " Shivani Bhasin Sachdeva is the Founder and Chief Executive Officer at India Alternatives. Shivani has over 15 years of private equity experience in the USA and in India at top notch private equity funds including IDFC Private Equity, Lightyear Capital and GE Equity where she has been responsible for deal sourcing, execution and monitoring companies across various sectors. Shivani has helped shape strategy at various companies through board level involvement and been instrumental in generating superior returns for her investors. Shivani is an MBA from Wharton and a BA from Mount Holyoke College (Massachusetts).\n\n        ",
	  name: "Shivani Bhasin Sachdeva",
	  post: " Founder & CEO",
	  cmp: "India Alternatives",
	  link: "https://in.linkedin.com/in/shivani-bhasin-sachdeva-47234757"
	
	}, {
	  imgUrl: icon7,
	  into: "As the founder of Waterfield Advisors, Soumya brings over 25 years of financial",
	  desc: "Soumya is the founder and CEO of Waterfield Advisors, which is the largest multi-family office and wealth advisory firm in India. With over 25 years of experience in private banking and wealth advisory, Soumya commenced her career at ANZ Grindlays Bank, which later became Standard Chartered Bank. She worked for 17 years with the Bank in both India and Singapore, with her last role being the head of the Private Banking division of Standard Chartered in India. In 2011, she established Waterfield Advisors.\n        <br/><br/>\n        As one of the earliest advocates of fee-only investment advisory in India, Soumya founded Waterfield on the principles of an alignment of interests with clients in the wealth advisory space. Today, Waterfield advises on financial assets exceeding $4 billion on behalf of India's leading and some of the most iconic business families. She also provides guidance to these families on non-investment issues such as succession planning, corporate and family governance, business strategy, and philanthropy. Soumya's leadership has contributed to Waterfield's reputation as one of India's largest and most-awarded wealth management firms.\n        <br/><br/>\n        In recognition of her contributions to the wealth management industry and as an entrepreneur, Soumya has received several awards and honours. She was awarded Woman Entrepreneur of the Year (Finance Category) by Financial Express in 2023, listed in Forbes India's Most Powerful Women\u2019s List in 2021, won the Private Banker International's Outstanding Private Banker (Asia Pacific) award in 2021 and served on the global jury of the Euromoney Global Private Banking Awards in 2023.\n        <br/><br/>\n        Soumya is a member of the Advisory Committee of BASL, the regulatory and supervisory body for Registered Investment Advisors (RIAs) in India and serves as a Board member of several non-profit organizations in the education and healthcare sectors. She was awarded the Radhakrishnan Scholarship to study at Oxford University, UK, where she earned her Masters in Mathematics, in addition to holding a B.A (Hons) in Mathematics from St. Stephen's College, Delhi.\n        \n        \n        ",
	  name: "Soumya Rajan",
	  post: "Founder & CEO",
	  cmp: "Waterfield Advisors",
	  link: "https://in.linkedin.com/in/soumya-rajan-124b9b66"
	}, {
	  imgUrl: icon32,
	
	  desc: "Sujoy Bose is the CEO \u2013 Investment Management, spearheading capital formation, deal sourcing, fund governance, and ESG & impact initiatives. He manages capital raising efforts, strengthening relationships with Limited Partners (LPs), and enhancing the firm\u2019s deal flow across various sectors. Sujoy brings to the firm over 30 years of experience in fund management, infrastructure investment, and strategic leadership. He previously led India\u2019s National Investment and Infrastructure Fund (NIIF) as Managing Director and CEO, overseeing its growth into a leading investment and infrastructure management entity in just seven years. Prior to NIIF, he spent 23 years at the International Finance Corporation (IFC), where he held pivotal roles such as Global Co-Head of Infrastructure and Natural Resources and Chief Investment Officer of IFC Asset Management. Sujoy started his career with Citibank in India. He holds an MBA from Rice University, Houston, and a B.Com from St. Xavier\u2019s College, Kolkata.\n\n        ",
	  name: "Sujoy Bose",
	  post: "CEO, Investment Management",
	  cmp: "Everstone",
	  link: "https://www.linkedin.com/in/sujoy-bose-ab675224/"
	}, {
	  imgUrl: icon30,
	  into: "VT Bharadwaj is a co-founder and General Partner at A91 Partners",
	  desc: "VT Bharadwaj is a General Partner at A91 Partners, an Indian private investment firm that seeks to partner with founders to build enduring businesses for tomorrow\u2019s India.<br/><br/>\n \n        Prior to co-founding A91 Partners, VT was a Managing Director at Sequoia Capital, a global venture capital firm in India where he led investments in consumer, pharmaceutical and healthcare sectors. Prior to that he worked at McKinsey & Co.<br/><br/>\n         \n        VT has an MBA from Indian Institute of Management Ahmedabad and a BE (Hons) in Electrical and Electronics Engineering from BITS Pilani\n        <br/><br/>\n        VT is a trustee at Ashoka University, a board member of IIM Ahmedabad Endowment Management Company, a Founding Circle member of Museum of Art & Photography and involved with Cuddles Foundation and Swasth Foundation.\n        ",
	  name: "VT Bharadwaj",
	  post: "Co-founder and General Partner",
	  cmp: "A91 Partners",
	  link: "https://in.linkedin.com/in/vt-bharadwaj-2333ba1"
	}];
	
	exports.default = mentors_constants;
	module.exports = exports["default"];

/***/ }),

/***/ 414:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Mentors = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(572);
	
	var _Modal = __webpack_require__(21);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	__webpack_require__(19);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _contentPage = __webpack_require__(16);
	
	var _contentPage2 = _interopRequireDefault(_contentPage);
	
	var _meta = __webpack_require__(17);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	var _mentors = __webpack_require__(403);
	
	var _mentors2 = _interopRequireDefault(_mentors);
	
	var _knowledgeCenter = __webpack_require__(44);
	
	var _knowledgeCenter2 = _interopRequireDefault(_knowledgeCenter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TeamModal = function TeamModal(_ref) {
		var activeItem = _ref.activeItem,
		    show = _ref.show,
		    onHide = _ref.onHide;
	
		return _react2.default.createElement(
			_Modal2.default,
			{ direction: '', className: 'teamdetails__wrapper', show: show, onHide: onHide },
			_react2.default.createElement(
				_Modal2.default.Header,
				null,
				_react2.default.createElement(
					'div',
					{ className: 'head_section' },
					_react2.default.createElement(
						'span',
						{ className: 'item_name' },
						activeItem.name
					),
					_react2.default.createElement(
						'div',
						{ className: 'item_des' },
						activeItem.post
					),
					_react2.default.createElement(
						'div',
						{ className: 'item_des' },
						activeItem.cmp
					)
				),
				_react2.default.createElement(
					'span',
					{ className: 'cross pull-right' },
					_react2.default.createElement('i', { onClick: onHide, className: 'fa fa-times' })
				)
			),
			_react2.default.createElement(
				_Modal2.default.Body,
				null,
				_react2.default.createElement(
					'div',
					{ className: 'item__desc' },
					_react2.default.createElement('div', { className: 'item__desc_scr', style: { padding: "0px 10px 0px 0px" }, dangerouslySetInnerHTML: { __html: activeItem.desc } })
				)
			),
			_react2.default.createElement(_Modal2.default.Footer, null)
		);
	};
	
	TeamModal.propTypes = {
		activeItem: _propTypes2.default.object,
		show: _propTypes2.default.object,
		onHide: _propTypes2.default.object
	};
	
	var Mentors = exports.Mentors = function (_React$Component) {
		_inherits(Mentors, _React$Component);
	
		function Mentors(args) {
			_classCallCheck(this, Mentors);
	
			var _this = _possibleConstructorReturn(this, _React$Component.call(this, args));
	
			_this.togglePopUp = function (item) {
				_this.setState({
					isShow: !_this.state.isShow,
					activeItem: item || {}
				});
			};
	
			_this.state = {
				activeItem: {},
				isShow: false
			};
			return _this;
		}
	
		Mentors.prototype.render = function render() {
			var _this2 = this;
	
			var location = this.props.location;
			var isShow = this.state.isShow;
	
			return _react2.default.createElement(
				_contentPage2.default,
				null,
				_react2.default.createElement(_meta2.default, { title: 'Winpe ProClub Mentorship Program | Mentors', description: 'Our mentors include eminent industry leaders who have had a rich professional and leadership journey and who are now keen to support the growth of female talent into future leaders.', image: "https://winpeforum.com/assets/elements/winpe_proclub_updated_linkimage1.jpg", location: location }),
				_react2.default.createElement(
					'div',
					{ className: 'mentors-wrapper' },
					_react2.default.createElement(
						'section',
						{ id: 'team', className: 'pb-5' },
						_react2.default.createElement(
							'div',
							{ className: 'container' },
							_react2.default.createElement(
								'h1',
								{ className: 'section-title h1' },
								'Mentors',
								_react2.default.createElement('br', null),
								'Cohort V'
							),
							_react2.default.createElement(
								'div',
								{ className: 'section_intro_text' },
								'Our mentors include eminent industry leaders who have had a rich professional and leadership journey and who are now keen to support the growth of female talent into future leaders.'
							),
							_react2.default.createElement(
								'div',
								{ className: 'row' },
								_mentors2.default.map(function (item, i) {
									return _react2.default.createElement(
										'div',
										{ className: 'col-xs-12 col-sm-6 col-md-4' },
										_react2.default.createElement(
											'div',
											{ className: '' },
											_react2.default.createElement(
												'div',
												{ className: 'mainflip flip-0', style: { minHeight: '450px' } },
												_react2.default.createElement(
													'div',
													{ className: 'frontside' },
													_react2.default.createElement(
														'div',
														{ className: 'card' },
														_react2.default.createElement(
															'div',
															{ className: 'card-body text-center mt-4' },
															_react2.default.createElement(
																'p',
																null,
																_react2.default.createElement('img', { onClick: function onClick() {
																		return _this2.togglePopUp(item);
																	}, className: ' img-fluid', src: item.imgUrl, alt: item.name })
															),
															_react2.default.createElement(
																'div',
																{ className: 'car_title' },
																item.name
															),
															_react2.default.createElement(
																'div',
																{ className: 'car_text1' },
																item.post
															),
															_react2.default.createElement(
																'div',
																{ className: 'car_text1' },
																item.cmp
															),
															_react2.default.createElement(
																'div',
																{ className: 'car_text', style: { height: 'auto' } },
																item.cohort
															),
															_react2.default.createElement(
																'a',
																{ target: '_blank', href: item.link, className: 'btn btn-primary btn-sm' },
																_react2.default.createElement('i', { className: 'fa fa-linkedin' })
															)
														)
													)
												)
											)
										)
									);
								}),
								_react2.default.createElement(
									'div',
									{ className: 'col-xs-12 col-sm-6 col-md-4' },
									_react2.default.createElement(
										'div',
										{ className: '' },
										_react2.default.createElement(
											'div',
											{ className: 'mainflip flip-0' },
											_react2.default.createElement(
												'div',
												{ className: 'frontside' },
												_react2.default.createElement(
													'div',
													{ className: 'card' },
													_react2.default.createElement(
														'div',
														{ className: 'card-body text-center mt-4' },
														'\xA0'
													)
												)
											)
										)
									)
								)
							)
						),
						_react2.default.createElement(TeamModal, { show: isShow, onHide: this.togglePopUp, activeItem: this.state.activeItem })
					)
				)
			);
		};
	
		return Mentors;
	}(_react2.default.Component);
	
	Mentors.propTypes = {
		location: _propTypes2.default.object
	};
	
	exports.default = Mentors;

/***/ }),

/***/ 572:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-cohort-v-mentors-index-jsx-8f51b9978ba2bd919bea.js